// Copyright 2025. WebPros International GmbH. All rights reserved.

export const ACTIONS = {
    DISASTER_RECOVERY_ENABLE_SWITCH: 'disaster-recovery-enable-switch',
};